import posed from 'react-pose';

const PoseAnimateItem = posed.button({
  openMenu: { y: 0, opacity: 1 },
  closeMenu: { y: 50, opacity: 0 },
});

export default PoseAnimateItem;
